module.exports = __webpack_public_path__ + "images/emoji/tiger.8f8c47d76deba9419b16.png";